import path from "path";

import { ObservableValueProducerBase } from "../../Commons/TasksCore/ChainableValueProducer";
import { buildActionBegin, ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";
import { ProcessUtils } from "../ProcessUtils/ProcessUtils";
import { IValueProducer } from "../../Commons/TasksCore/BuildTask";

export class BuildCandyWidgetTask extends ObservableValueProducerBase<string> {
    private readonly pathToViteProvider: IValueProducer<string>;
    private readonly logger: ILogger;

    public constructor(pathToViteProvider: IValueProducer<string>, logger?: ILogger) {
        super();
        this.pathToViteProvider = pathToViteProvider;
        this.logger = (logger || getLogger()).withPrefix("CANDY_WIDGET");
    }

    public async getCurrentValue(): Promise<string> {
        const viteConfigFile = await this.pathToViteProvider.currentValue;
        await this.buildWidgetFromSources(viteConfigFile);

        return viteConfigFile;
    }

    private async buildWidgetFromSources(configPath: string): Promise<void> {
        const action = buildActionBegin(this.logger, "Build Candy widget");
        const workingDirectory = path.dirname(configPath);
        const buildProcess = ProcessUtils.createShellProcess(`npm`, ["run", "build:withInstall"], workingDirectory);

        buildProcess.onStdOut.subscribe(data => this.logger.log(data.trimRight()));
        buildProcess.start();
        const code = await buildProcess.waitForExit();
        if (code !== 0) {
            throw new Error(`Executed with exit code ${code}`);
        }
        action.complete();
    }
}
